const getters = {
  user: state => state.user,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  orgInfo: state => state.user.orgInfo,
  // currentNode: state => state.app.currentNode
  sidebar: state => state.app.sidebar,
  device: state => state.app.device
}
export default getters
